import {Component, OnInit} from '@angular/core';
import {Location} from '@angular/common';

import {Params, ActivatedRoute} from "@angular/router";
import {DataService} from "../services/data.service";
import {ApiService} from "../services/api.service";
import {Mailchimp} from "../type/mailchimp";
import {Category} from "../type/category";

@Component({
    selector: 'app-mailchimp-list-edit',
    templateUrl: './mailchimp-list-edit.component.html',
    styles: []
})
export class MailchimpListEditComponent implements OnInit {

    node = 'mailchimp/list';
    companyCategoryNode = 'company-category';
    mailChimpList: Mailchimp = Mailchimp;
    companyCategories: [Category] = [Category];

    constructor(private dataService: DataService,
                private apiService: ApiService,
                private route: ActivatedRoute,
                private location: Location) {
    }

    ngOnInit(): void {
        this.dataService.refresh();
        this.route.params
            .subscribe(
                (params: Params) => {
                    this.apiService.getUsingId(this.node, +params['id'])
                        .subscribe((response) => {
                            this.dataService.updateActiveRequestNo(-1);
                            this.mailChimpList = response.json().data[0]
                        });
                }
            );
        this.getCompanyCategories();
    }

    getCompanyCategories() {
        this.apiService.getAll(this.companyCategoryNode)
            .subscribe((response) => {
                this.dataService.updateActiveRequestNo(-1);
                if (response.json().error == true) {
                    this.companyCategories = [Category];
                } else {
                    this.companyCategories = response.json().data;
                }
            });
    }

    onFormSubmit() {
        this.apiService.update(this.node, [this.mailChimpList.mail_chimp_list_id], this.mailChimpList)
            .subscribe((response) => {
                    this.dataService.updateActiveRequestNo(-1);
                    if (response.json().error == true) {
                        alert('Error: Unable to submit form');
                    } else {
                        alert('Success: List updated successfully');
                        this.location.back();
                    }
                },
                (error) => alert('Error: Unable to submit form')
            );
    }

    checkPermission(module, method) {
        return this.dataService.checkPermission(module, method);
    }
}



// WEBPACK FOOTER //
// ./src/app/mailchimp/mailchimp-list-edit.component.ts